app.component("medicationTile", {
    templateUrl: "app/src/js/components/medications/MedicationTile.html",
    controller: "medicationTileController",
    bindings: {
        patientId: "=",
        onPrescriptionUpdate: "<",
        registration: "&",
    },
});

app.controller("medicationTileController", [
    "$scope",
    "$modal",
    "$filter",
    "MedicationAPI",
    "NHISearchPatientsAPI",
    "CurrentPatient",
    "Session",
    "countryConfig",
    "HPI_PHARMACY_SEARCH",
    "InfoPopoverHover",
    "PrescriptionFieldsService",
    function ($scope, $modal, $filter, MedicationAPI, NHISearchPatientsAPI, CurrentPatient, Session, countryConfig, HPI_PHARMACY_SEARCH, InfoPopoverHover, PrescriptionFieldsService) {
        this.$onInit = function () {
            this.registration({
                handler: this.triggerUpdate
            });
        };

        // options.background: a live update - fetch without the spinner.
        this.triggerUpdate = function (options) {
            fetchPatientsMedication(options);
        }
        $scope.MA = MedicationAPI;
        $scope.HPI = NHISearchPatientsAPI;
        $scope.hpiPharamcySearchEnabled = HPI_PHARMACY_SEARCH;
        InfoPopoverHover.attach($scope);

        $scope.CP = CurrentPatient;
        $scope.patientMedication = [];
        $scope.isSubmitting = false;
        $scope.positiveClick = undefined;
        $scope.isNormalPrescription = { value: true };
        $scope.countryConfig = countryConfig;
        $scope.pharmacyTerm = "";

        $scope.formData = {
            pharmacy: "",
            search_term: "",
            pharmacy_object: null,
        };

        // The dialog records medications and allergies, so it opens for anyone who may do either.
        $scope.canEditMedicationsOrAllergies = Session.hasPermission("CLINICAL_MEDICATION_PRESCRIBE")
            || Session.hasPermission("PATIENT_ALLERGY_MANAGE");
        // A live update that arrives while the medication dialog is open is held until it closes. The
        // dialog's form is bound to patientMedication itself, so replacing the list under it would throw
        // away medications added and flags changed but not yet saved.
        var refreshWhenModalCloses = false;

        function fetchPatientsMedication(options) {
            const background = !!(options && options.background);
            if (background && $scope.medicationModal && $scope.medicationModal.$isShown) {
                refreshWhenModalCloses = true;
                return;
            }
            if (!background) $scope.MA.isProcessing = true;
            $scope.MA.getPatientsMedication($scope.$ctrl.patientId).then(function (resp) {
                $scope.patientMedication = resp.data;
                checkNonPrescribeMedication($scope.patientMedication);
                $scope.patientMedicationCopy = angular.copy($scope.patientMedication);
                const array = $scope.filterRegular(resp.data);
                // const rows = [];
                const filteredData = [];
                const od_array_simple = array.filter(t => t.route === 'OD' || t.route === 'Right Eye' || t.route === 'BOTH' || t.route === 'Both Eyes');
                const os_array_simple = array.filter(t => t.route === 'OS' || t.route === 'Left Eye' || t.route === 'BOTH' || t.route === 'Both Eyes');

                const rows_count_simple = Math.max(od_array_simple.length, os_array_simple.length);
                for (let i = 0; i < rows_count_simple; i++) {
                    filteredData.push({ od: od_array_simple[i], os: os_array_simple[i] });
                }
                // $scope.diagnosisData_ocular = rows;
                $scope.filteredData = filteredData;
            },
                function (error) {
                    console.error(error && error.status);
                }).then(function () {
                    if (!background) $scope.MA.isProcessing = false;
                })
        }

        $scope.$watch(
            "$ctrl.patientId",
            function (newValue, oldValue) {
                if (newValue && Session.hasPermission("CLINICAL_MEDICATION_VIEW")) {
                    fetchPatientsMedication();
                }
            },
            true
        );

        function checkNonPrescribeMedication(medications) {
            if (medications.find(t => t.electronic_prescription_available !== null && !t.electronic_prescription_available)) {
                $scope.isEDisabled = true;
                $scope.isNormalPrescription.value = true;
            } else {
                $scope.isEDisabled = false;
            }

        }

        $scope.$watch("patientMedication", function (newValue, oldValue) {
            if (newValue) {
                checkNonPrescribeMedication(newValue);
            }
        }, true);

        $scope.onMedicationUpdate = function () {
            fetchPatientsMedication();
        }

        function getFileName() {
            var theTime = $filter("date")(new Date(), "yyyy-MM-dd@hmma");
            return (
                "CatTrax_prescription_" +
                theTime +
                "_" +
                $scope.CP.patient.firstName +
                "_" +
                $scope.CP.patient.lastName +
                "_" +
                $scope.CP.patient.dateOfBirth +
                ".pdf"
            );
        }

        $scope.isPrescriptionDisabled = function () {
            // Also keep SAVE/PRESCRIBE disabled while a save is in flight so the
            // medications can't be posted twice by a double click.
            return $scope.isSubmitting || $scope.patientMedication.length === 0;
        }

        // Generating a prescription is restricted to prescribing roles (hasSubmitMedicationRole).
        $scope.canGeneratePrescription = Session.canSubmitMedication();

        $scope.isGeneratePrescriptionDisabled = function () {
            return !$scope.canGeneratePrescription || $scope.isPrescriptionDisabled();
        }

        $scope.addMedicationPrescription = function (isPrescription) {
            // Guard against double submission: ignore further clicks while a save is
            // in flight (isPrescriptionDisabled() also disables the buttons).
            if ($scope.isSubmitting) {
                return;
            }
            $scope.isSubmitting = true;
            $scope.MA.isProcessing = true;
            const array = $scope.patientMedication.filter(t => t.medication_id == null);
            const data = array.map(t => ({ ...t, comments: t.comments[0].comment }));

            const post_op_array = $scope.patientMedication.filter(t => t.medication_type !== 'REGULAR' && t.medication_id).map(u => u.medication_id);

            const deleted = [];
            if ($scope.patientMedicationCopy) {
                $scope.patientMedicationCopy.forEach(element => {
                    if (!$scope.patientMedication.some(m => m.medication_id === element.medication_id)) {
                        deleted.push(element.medication_id);
                    }
                });
            }


            $scope.MA.addMedication($scope.$ctrl.patientId, data).then(function (resp) {
                // Only remove medications once the new ones are saved, so a failed save loses nothing.
                // user case 1: Uncheck regular, click ’save’, this medication will disappear;
                // User case 3: Uncheck regular, click ’prescribe ’, this medication will disappear on dashboard, still on the pdf, not save in the next time
                post_op_array.forEach(element => {
                    $scope.MA.deleteMedication($scope.$ctrl.patientId, element).then(function (resp) { }, function (error) { });
                });

                if (isPrescription) {
                    const regularArray = resp.data;
                    const _data = $scope.patientMedication.filter(t => t.medication_id !== undefined).concat(regularArray);
                    prescription(_data);
                    return;
                }

                // User case 6: Uncheck regular, then click ‘X’ button, click ‘save’, delete the medication
                deleted.forEach(element => {
                    if (element.medication_type !== 'REGULAR') {
                        $scope.MA.deleteMedication($scope.$ctrl.patientId, element).then(function (resp) { }, function (error) { });
                    }
                });

                setTimeout(() => {
                    fetchPatientsMedication();
                    $scope.$ctrl.onPrescriptionUpdate();
                    if ($scope.medicationModal) {
                        $scope.medicationModal.hide();
                        $scope.medicationModal = null;
                    }
                    $scope.isSubmitting = false;
                    $scope.$applyAsync();
                }, 1000);
            },
                function (error) {
                    // Let the user retry after a failure; keep the modal and its medications open.
                    $scope.isSubmitting = false;
                    $scope.MA.isProcessing = false;
                    $scope.serverErrorModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                        show: true,
                        title: "CatTrax has encountered an error",
                    });
                    console.error("Failed to save medications", error && error.status);
                });
        }

        function prescription(data) {
            $scope.MA.isProcessing = true;
            const array = data.map(t => {
                return {
                    dose: `${t.dose_quantity} ${t.dose_unit}`,
                    dose_quantity: t.dose_quantity,
                    dose_unit: t.dose_unit,
                    frequency: t.frequency,
                    route: t.route,
                    duration: t.duration,
                    comments: (t.comments && t.comments.length > 0) ? t.comments[0].comment : '',
                    snomed_medication_id: t.snomed_medication_id,
                    medication_nzulm_id: t.medication_nzulm_id,
                    medication_source_type: t.medication_source_type,
                    // Country-specific fields (AU: PBS); none in NZ.
                    ...PrescriptionFieldsService.toPayload(t)
                };
            });
            const regularList = data.filter(t => t.medication_type === "REGULAR").map(m => m.medication_id);

            if (regularList.length > 0) {
                $scope.MA.changeRegularMedication($scope.$ctrl.patientId, regularList);
            }

            if (!$scope.isNormalPrescription.value && $scope.formData.pharmacy_object) {
                // e-prescription//
                $scope.MA.electronicPrescription($scope.$ctrl.patientId, array, getIdFromPharmacyObject($scope.formData.pharmacy_object)).then(function (resp) {
                    $scope.MA.isProcessing = false;
                    $scope.isSubmitting = false;
                    // show e-prescription confirm modal
                    $scope.successObj = {
                        patientName: $scope.CP.patient.firstName + ' ' + $scope.CP.patient.lastName,
                        pharmacy: $scope.formData.pharmacyTerm
                    };
                    $scope.successModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.e-prescription.tpl.html",
                        show: true,
                        title: "Success",
                        onHide: function () {
                            fetchPatientsMedication();
                            $scope.$ctrl.onPrescriptionUpdate();
                            if ($scope.medicationModal) {
                                $scope.medicationModal.hide();
                                $scope.medicationModal = null;
                            }
                        },
                    });


                },
                    function (error) {
                        $scope.MA.isProcessing = false;
                        $scope.isSubmitting = false;
                        console.error(error && error.status);
                        $scope.serverErrorModal = $modal({
                            scope: $scope,
                            templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                            show: true,
                            title: "CatTrax has encountered an error",
                        });
                    })
                return;
            }




            $scope.MA.prescription($scope.$ctrl.patientId, array).then(function (resp) {
                downloadFile(resp.data, getFileName());
                fetchPatientsMedication();
                $scope.$ctrl.onPrescriptionUpdate();
                if ($scope.medicationModal) {
                    $scope.medicationModal.hide();
                    $scope.medicationModal = null;
                }
            },
                function (error) {
                    console.error(error && error.status);
                    $scope.serverErrorModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                        show: true,
                        title: "CatTrax has encountered an error",
                    });
                }).then(function () {
                    $scope.MA.isProcessing = false;
                    $scope.isSubmitting = false;
                })
        }

        function downloadFile(data, filename, mime, bom) {
            // https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
            var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
            var blob = new Blob(blobData, { type: "application/pdf" });
            if (typeof window.navigator.msSaveBlob !== "undefined") {
                // IE workaround for "HTML7007: One or more blob URLs were
                // revoked by closing the blob for which they were created.
                // These URLs will no longer resolve as the data backing
                // the URL has been freed."
                window.navigator.msSaveBlob(blob, filename);
            } else {
                var blobURL = window.URL.createObjectURL(blob);
                var tempLink = document.createElement("a");
                tempLink.style.display = "none";
                tempLink.href = blobURL;
                tempLink.setAttribute("download", filename);

                // Safari thinks _blank anchor are pop ups. We only want to set _blank
                // target if the browser does not support the HTML5 download attribute.
                // This allows you to download files in desktop safari if pop up blocking
                // is enabled.
                if (typeof tempLink.download === "undefined") {
                    tempLink.setAttribute("target", "_blank");
                }

                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(blobURL);
                $scope.displaySpinner = false;
            }
        }

        $scope.closeMedicationModal = function () {
            $scope.positiveClick = function () {
                if ($scope.serverErrorModal) {
                    $scope.alertMessage = null;
                    $scope.serverErrorModal.hide();
                    $scope.serverErrorModal = null;
                }
                if ($scope.medicationModal) {
                    $scope.medicationModal.hide();
                    $scope.medicationModal = null;
                    fetchPatientsMedication();
                }
                $scope.positiveClick = undefined;
            }
            $scope.alertMessage = "If you quit now any new medications that have been added will not be saved and a prescription will not be generated.";
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "The prescription has not yet been generated",
                backdrop: "static",
                keyboard: false,
            });

        }

        $scope.filterRegular = function (array) {
            return array.filter(t => t.medication_type === 'REGULAR');
        }

        function fetchPatientSetting() {
            if (!Session.hasPermission("CLINICAL_MEDICATION_PRESCRIBE")) return;
            $scope.MA.getPatientSettings($scope.CP.patient.id).then(
                function (resp) {
                    if (resp.data && resp.data.preferred_pharmacy) {
                        const obj = { ...resp.data.preferred_pharmacy, pharmacyId: resp.data.preferred_pharmacy.pharmacy_id }
                        $scope.formData.pharmacyTerm = obj.premises_name;
                        $scope.formData.pharmacy_object = obj;
                    }
                },
                function (err) {
                    console.log(err && err.status)
                }
            );
        }

        $scope.showMedicationModal = function () {
            $scope.isNormalPrescription.value = true;
            $scope.pharmacy = {};
            $scope.formData = {
                pharmacy: "",
                search_term: "",
                pharmacy_object: null,
            };
            fetchPatientSetting();
            $scope.medicationModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.medication-form.tpl.html",
                show: true,
                title: "Medications",
                backdrop: "static",
                keyboard: false,
                onShow: function () {
                    const target = $scope.patientMedication.find(t => t.electronic_prescription_available !== null && !t.electronic_prescription_available);
                    if (target && $scope.countryConfig.ePrescriptionsFeatureEnabled) {
                        $scope.alertMessage = `${target.medication} is a Class C controlled drug and is not available on e-prescription. If you wish to prescribe codeine please print and sign your prescription`;
                        $scope.serverErrorModal = $modal({
                            scope: $scope,
                            templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                            show: true,
                            title: "",
                        });

                    }
                },
                onHide: function () {
                    // Catch up with whatever changed while the dialog was open - see fetchPatientsMedication().
                    if (refreshWhenModalCloses) {
                        refreshWhenModalCloses = false;
                        fetchPatientsMedication({ background: true });
                    }
                }
            });
        }

        $scope.fetch = function (value) {
            $scope.loading = true;
            $scope.formData.pharmacyTermBackup = value;
            $scope.formData.pharmacyTerm = null;
            $scope.formData.pharmacy_object = null;
            return new Promise((resolve, reject) => {
                queryPharmacy(value, resolve, reject);
            });
        };

        function queryPharmacy(terms, resolve, reject) {
            $scope.result = [];
            $scope.noResults = false;
            if ($scope.hpiPharamcySearchEnabled && Session.practice.practiceFeatures && Session.practice.practiceFeatures.fhirNhiFeature) {
                $scope.formData.pharmacyIsHpiLocation = true;
                $scope.HPI.queryLocationsByTermsAndPharmacy(terms)
                    .then(
                        function (resp) {
                            if (resp.data) {
                                $scope.result = resp.data;
                            } else {
                                $scope.result = [];
                            }
                            $scope.formData.search_term = terms;
                            resolve($scope.result);
                        },
                        function (err) {
                            console.log(err && err.status)
                            $scope.noResults = true;
                            $scope.result = [];
                            reject(err)
                        }
                    ).then(function () {
                        $scope.loading = false;
                    })
            } else {
                $scope.formData.pharmacyIsHpiLocation = false;
                $scope.MA.queryPharmacy(terms)
                    .then(
                        function (resp) {
                            if (resp.data) {
                                $scope.result = resp.data;
                                $scope.formData.search_term = terms;
                                resolve($scope.result)
                            }
                        },
                        function (err) {
                            console.log(err && err.status)
                            $scope.noResults = true;
                            $scope.result = [];
                            reject(err)
                        }
                    ).then(function () {
                        $scope.loading = false;
                    })
            }
            $scope.pharmacyNoEmailErrorMessage = "";
        }

        function getIdFromPharmacyObject(item) {
            if ($scope.formData.pharmacyIsHpiLocation) {
                for (let idObj of item.location_id) {
                    if (idObj.system === 'https://standards.digital.health.nz/ns/hpi-facility-id' && idObj.use === 'Official') {
                        return idObj.value;
                    }
                }
            } else {
                return item.pharmacy_id;
            }
        };

        $scope.formatHpiId = function (item) {
            if (item.system === 'https://standards.digital.health.nz/ns/hpi-facility-id') {
                return `HPI ID: ${item.value} (${item.use})`;
            }
            if (item.system === 'https://standards.digital.health.nz/ns/hpi-nzbn') {
                return `NZBN ID: ${item.value} (${item.use})`;
            }
            if (item.system === 'https://standards.digital.health.nz/ns/nzhis-facility-id') {
                return `NZHIS ID: ${item.value} (${item.use})`;
            }
            if (item.system === 'https://standards.digital.health.nz/ns/nzhis-agency-id') {
                return `Agency ID: ${item.value} (${item.use})`;
            }

            return `${item.system}: ${item.value} (${item.use})`;
        };

        $scope.formatPharmacy = function (model) {
            if (!model) return '';
            if (model.premisesName) {
                return model.premises_name + ' ' + model.address;
            }
            var aliases = MTC.getFilteredAliases(model);
            return model.name + (aliases.length > 0 ? ' (aliases: ' + aliases.join(', ') + ')' : '');
        };

        $scope.getFilteredAliases = function (item) {
            if (!item || !item.alias) return [];
            return item.alias.filter(function (alias) {
                return alias !== item.name;
            });
        };

        $scope.pharmacyOnSelect = function (item) {
            $scope.formData.pharmacy_object = item;
            if ($scope.formData.pharmacyIsHpiLocation) {
                $scope.formData.pharmacyTerm = $scope.formData.pharmacyTermBackup;
            } else {
                $scope.formData.pharmacyTerm = item.premises_name;
            }
            if (!item.email) {
                $scope.pharmacyNoEmailErrorMessage = "Unabled to generate prescription: selected pharmacy does not have an email.";
                return;
            }
        }
    },
]);